import { render, staticRenderFns } from "./PT485MemberCouponListParts.vue?vue&type=template&id=1ce89556&"
import script from "./PT485MemberCouponListParts.vue?vue&type=script&lang=js&"
export * from "./PT485MemberCouponListParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports